<template>
  <div>
    <b-container>
      <div class="row" v-if="!this.showRecover">
        <div class="col-sm-9 col-md-7 col-lg-5 mx-auto">
          <b-card class="my-5">
            <form @submit="loginUser">
              <div class="mt-3 mb-3">
                  <img src="static/logo_easyOrange.png" width="100" height="100" />
              </div>
              <div class="text-center mt-3 mb-3">
                <h3>
                  <img src="static/logo_login.png" width="30" height="30" />
                  {{this.$title_application }}
                </h3>
              </div>              <b-form-group>
                <label>Usuario</label>
                <b-form-input type="text" v-model="user" placeholder="Ingrese el usuario" required />
              </b-form-group>

              <b-form-group>
                <label>Contraseña</label>
                <b-form-input
                  type="password"
                  v-model="password"
                  placeholder="Ingrese la contraseña"
                  required
                />
              </b-form-group>

              <b-button type="submit" block variant="primary" class="mb-3">Ingresar</b-button>

              <div class="form-group">
                <b-link href="#" @click="showRecover = true">¿Olvidaste tu cuenta?</b-link>
              </div>
            </form>
          </b-card>
        </div>
      </div>
    </b-container>

    <div v-if="this.showRecover">
      <b-container>
        <div class="row">
          <div class="col-sm-9 col-md-7 col-lg-5 mx-auto">
            <b-card class="my-5">
              <form @submit="recoveryPassword">
                <h3 class="text-center mt-3 mb-3">Recuperar Contraseña</h3>
                <b-form-group>
                  <label>Correo electronico</label>
                  <b-form-input
                    type="email"
                    v-model="mail"
                    placeholder="Ingrese el correo electronico"
                    required
                  />
                </b-form-group>

                <b-button type="submit" block variant="primary" class="mb-3">Enviar</b-button>
                <b-button
                  type="button"
                  block
                  variant="secondary"
                  class="mb-3"
                  @click="showRecover = false"
                >Cancelar</b-button>
              </form>
            </b-card>
          </div>
        </div>
      </b-container>
    </div>
  </div>
</template>

<script>
export default {
  name: "Login",
  data() {
    return {
      user: "",
      password: "",
      mail: "",
      showRecover: false
    };
  },
  methods: {
    loginUser(evt) {
      evt.preventDefault();
      var left = this;
      this.axios
        .post(this.$apiURI_users + "/api/v1/users/validate", {
          username: this.user,
          password: this.password
        })
        .then(response => {
          left.$router.push("/");
          left.$store.dispatch("loginUser", {
            access: response.data.token,
            refresh: response.data.token
          });
        });
    },
    recoveryPassword(evt) {
      evt.preventDefault();
      const left = this;
      this.axios
        .post(this.$apiURI_users + "/api/v1/users/reset_password", {
          email: this.mail
        })
        .then(response => {
          left.$bvToast.toast(response.data.message, {
            title: "Correo de recuperación enviado",
            autoHideDelay: 3000,
            variant: "success"
          });
          left.showRecover = true;
        });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Login.vue